import {
  REQUEST_CLIENTIFY_FILTERS,
  REQUEST_CLIENTIFY_FILTERS_SUCCEEDED,
  REQUEST_CLIENTIFY_FILTERS_FAILED,
} from './action-types';

import utils from '../utils';

const initialState = {
  data: [],
  totals: {},
  loading: false,
};

const clientifyReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case REQUEST_CLIENTIFY_FILTERS:
    {
      return {
        ...state,
        loading: true,
      };
    }
    case REQUEST_CLIENTIFY_FILTERS_SUCCEEDED: {
      const {
        data, pages, bindingObject: { filters },
      } = action;
      return {
        ...state,
        data,
        filters,
        pages,
        loading: false,
      };
    }
    case REQUEST_CLIENTIFY_FILTERS_FAILED: {
      utils.dialog({
        type: 'warning',
        title: 'Error inesperado',
        message: 'No se ha podido recoger los logs de Clientify.',
      });
      return {
        ...state,
        loading: false,
      };
    }
    default:
      return state;
  }
};

export default clientifyReducer;
